var path = '/app/components/staticMap/staticmap.html';
var html = "<div class=rounded style=overflow:hidden> <img class=\"rounded centered float-lg-right\" ng-src={{ctrl.mapUrl}} /> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/staticMap/staticmap.html
// module id = 985
// module chunks = 0